import {
  Dialog,
  Toolbar,
  Slide,
  Grid,
  DialogTitle,
  DialogContent,
  Typography,
} from "@material-ui/core";
import { TransitionProps } from "@material-ui/core/transitions";
import { ButtonSubmit } from "..";
import { useStyles } from "./BoxDialog.styles";
import { useIntl } from "react-intl";
import React, { useState } from "react";
const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});
interface deleteAlertProps {
  alertClose: any;
  alertOpen: any;
  componentName: any;
  Submited: any;
  deletedValue: any;
  deletedDocumentData?: any;
  allDocumentsGroup?: any;
}
export const ArchiveAlert = ({
  alertClose,
  alertOpen,
  componentName,
  Submited,
  deletedValue,
  deletedDocumentData,
  allDocumentsGroup,
}: deleteAlertProps) => {
  const { formatMessage } = useIntl();
  const classes = useStyles();

  return (
    <div>
      <Dialog
        open={alertOpen}
        onClose={alertClose}
        TransitionComponent={Transition}
      >
        <DialogTitle id="alert-dialog-title" style={{ width: "100%" }}>
          {formatMessage({ id: componentName, defaultMessage: "Delete" })}
        </DialogTitle>
        <DialogContent>
        <Grid container>
              <Typography
                variant="h6"
                className={
                  componentName === "form.clientAdmin"
                    ? classes.deleteMessage2
                    : classes.deleteMessage
                }
              >
               {formatMessage({
                      id: "group.user.delete.message.archive",
                      defaultMessage: "Are you sure you want to archive",
                    })}
              </Typography>
              <Typography
                className={
                  componentName === "form.clientAdmin"
                    ? classes.deleteName2
                    : classes.deleteName
                }
              >
                {deletedValue}?
              </Typography>
            </Grid>
        </DialogContent>
        <Toolbar>
          <ButtonSubmit
            text={"form.no"}
            onClick={alertClose}
            className={classes.padding5}
          />
          <Grid container justifyContent={"flex-end"}>
            <ButtonSubmit text={"form.yes"} onClick={Submited} />
          </Grid>
        </Toolbar>
      </Dialog>
    </div>
  );
};
